import { useAudioPlayerContext } from './context/AudioPlayerContext';
import Music from '../../assets/icons/audioplayer/music.svg';
export const Track = () => {
  const { currentTrack } = useAudioPlayerContext();

  return (
    <div className="flex items-center gap-2 sm:gap-4">
      <div className="w-14 h-14 flex items-center justify-center shrink-0 rounded-md overflow-hidden">
        <img className="w-full h-full object-cover bg-gray-300 rounded-sm sm:rounded-full" src={currentTrack?.thumbnail || Music} srcSet={`${currentTrack?.thumbnail || Music} 1x, ${currentTrack?.thumbnail || Music} 2x`} loading="lazy" alt="audio avatar" />
      </div>
      <div className="flex flex-col gap-1 w-full">
        <p className="font-bold line-clamp-1 text-overflow-ellipsis overflow-hidden max-w-full" title={currentTrack?.title}>{currentTrack?.title}</p>
        <p className="text-sm line-clamp-1 text-gray-400" dangerouslySetInnerHTML={{ __html: currentTrack?.description }}></p>
      </div>
    </div>
  );
};